import React, { memo, useMemo, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryResultsTable.module.scss";
import { PupilResult } from "shared/types/sociometry";
import { getSociometryStarsIds } from "../lib/sociometryRoles";

import { SociometryResultItem } from "../SociometryResultItem/SociometryResultItem";
import { HStack } from "components/landingNew/shared/ui/Stack";
import { ReactComponent as ArrowDown } from "static/img/arrow-down.svg";
import { Icon } from "components/landingNew/shared/ui/Icon";

interface SociometryResultsTableProps {
    className?: string;
    scores: PupilResult[];
    sessionId: string;
    onAnnulled?: () => void;
}

export const SociometryResultsTable = memo((props: SociometryResultsTableProps) => {
    const { className, scores, sessionId, onAnnulled } = props;
    const starsIds = useMemo(() => getSociometryStarsIds(scores), [scores]);

    const passedTest = scores.filter((score) => score.answers.length > 0);
    const notPassedTest = scores.filter((score) => score.answers.length === 0);

    const sortedScores = [...passedTest, ...notPassedTest];

    const [showAll, setShowAll] = useState(false);

    const MAX_VISIBLE = 10;

    const visibleScores = showAll ? sortedScores : sortedScores.slice(0, MAX_VISIBLE);

    const hasMore = sortedScores.length > MAX_VISIBLE;

    return (
        <div className={classNames(cls.sociometryResultsTable, {}, [className])}>
            <div className={cls.rowHeader}>
                <div>Статус</div>
                <div>ФИО</div>
                <div className={cls.center}>+</div>
                <div className={cls.center}>-</div>
                <div className={cls.center}>Итог</div>
            </div>
            {visibleScores.map((score, index) => {
                const isNotPassed = score.answers.length === 0;

                const prevScore = visibleScores[index - 1];
                const showSeparator = isNotPassed && prevScore && prevScore.answers.length > 0;

                return (
                    <React.Fragment key={score.pupil?._id}>
                        {showSeparator && <p className={cls.notPassedTest}>Еще не прошли тестирование</p>}

                        <SociometryResultItem
                            score={score}
                            starsIds={starsIds}
                            className={cls.row}
                            notPassedTest={isNotPassed}
                            sessionId={sessionId}
                            onAnnulled={onAnnulled}
                        />
                    </React.Fragment>
                );
            })}
            {hasMore && (
                <HStack justify="center" max>
                    <div onClick={() => setShowAll((prev) => !prev)} className={cls.showAll}>
                        <p>{showAll ? "Скрыть" : `Показать всех учеников`}</p>

                        <Icon
                            Svg={ArrowDown}
                            className={classNames(cls.icon, { [cls.expanded]: showAll }, [])}
                            height={5}
                            width={9}
                        />
                    </div>
                </HStack>
            )}
        </div>
    );
});

SociometryResultsTable.displayName = "SociometryResultsTable";
